import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IVizRecommendationInfo } from '../models/IVizRecommendationInfo';
import { Module } from '../Module';
import { GetRecommendationsVizzesRequest } from '../ServerApi/requests/GetRecommendationsVizzesRequest';
import { FetcherFactory } from '../services/FetcherFactory';
import { ResourceQuery } from './ResourceQuery';

export class VizRecommendations {
  public static $inject = ['FetcherFactory'];

  private getRecommendationsVizzes: IListFetcher<IVizRecommendationInfo>;

  constructor(FetcherFactory: FetcherFactory) {
    this.getRecommendationsVizzes = FetcherFactory.getServerResourceFetcher(GetRecommendationsVizzesRequest, ServerApiMapper.vizRecommendations);
  }

  public vizRecommendations(): ResourceQuery<IVizRecommendationInfo> {
    return new ResourceQuery(this.getRecommendationsVizzes);
  }
}

Module.instance().service('VizRecommendations', VizRecommendations);
